/** @format */

import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { AlertCircle, Check } from 'mdi-material-ui';
import { BILLINGS_READABLE_CONSTANTS, checkEvent2 } from './BillingsHelper';

/** @format */

export default class ReportHelper {
    static prepareFilters = (filters) => {
        let params = {};
        filters.forEach((filter) => {
            if (filter.name.slice(-2) === '[]') {
                let name = filter.name.slice(0, -2);
                if (params[name] === null || typeof params[name] === 'undefined') {
                    params[name] = [];
                    params[name].push(filter.value);
                } else {
                    params[name].push(filter.value);
                }
            } else {
                params[filter.name] = filter.value;
            }
        });
        return params;
    };

    static canBeDeleted = (item) => {
        let allowed = false;

        switch (item.state) {
            case this.reportState.PENDING:
            case this.reportState.EXCEEDED_RETRIES:
            case this.reportState.FAILED:
            case this.reportState.COMPLETED:
            case this.reportState.DISCARDED:
                return false;
            default:
                return true;
        }
    };

    static getParamValue = (item, value, name, idTranslations) => {
        if (item.typeId === ReportHelper.reportType.BILLING) {
            if (name === 'type') {
                let typeParams = value.split(',');
                typeParams = typeParams.map((param) => {
                    return BILLINGS_READABLE_CONSTANTS[checkEvent2(parseInt(param))];
                });
                typeParams = typeParams.filter((v, i) => {
                    return typeParams.indexOf(v) === i;
                });
                return typeParams.join(', ');
            }
        }

        idTranslations.map((el) => {
            if(el.name) {
                if(name === el.name && el.name === 'platformResellerId') {
                    value = ReportHelper.translateResellerId(value,el.value);
                }
            }
        })

        switch (value) {
            case 'true':
                return 'Tak';
            case 'false':
                return 'Nie';
            default:
                return value;
        }
    };

    static reportState = {
        DISCARDED: -1,
        PENDING: 0,
        SELECTED_FOR_PROCESSING: 1,
        IN_PROGRESS: 2,
        FAILED: 400,
        EXCEEDED_RETRIES: 401,
        COMPLETED: 1000,
    };

    static reportType = {
        CLIENT_BALANCES: 1,
        BILLING: 2,
        CASE_STATES: 3,
        REPORT_ANALYTICS_ACCOUNT: 5,
        SPECIALIZED_REPORT: 9,
    };

    static reportTypeArr = [
        1,2,3,5,9
    ];

    static REPORTS_MNEMONICS = {
        ACTIVE_SIM_CARD: 'reports:type.active_sim_card',
        ACTIVE_USED_SIM_CARD: 'reports:type.active_and_used_sim_card',
        SIM_CARD_NUMBERING: 'reports:type.sim_card_numbering',
        SIM_CARD_OPERATION: 'reports:type.sim_card_operation',
        MAIN_FRACTION_MOVEMENT: 'reports:type.main_fraction_movement',
        DETAILED_FRACTION_MOVEMENT: 'reports:type.detailed_fraction_movement',
        ARPU_HURT: 'reports:type.arpu_hurt',
        MVNO_REVENUE: 'reports:type.mvno_revenue',
    };

    static renderProgress = (state, classes) => {
        switch (state) {
            case this.reportState.DISCARDED:
                return null;
            case this.reportState.PENDING:
                return null;
            case this.reportState.SELECTED_FOR_PROCESSING:
                return <CircularProgress className={classes.progress} />;
            case this.reportState.IN_PROGRESS:
                return <CircularProgress className={classes.progress} />;
            case this.reportState.FAILED:
                return <AlertCircle style={{ color: 'red' }} />;
            case this.reportState.EXCEEDED_RETRIES:
                return <AlertCircle style={{ color: 'red' }} />;
            case this.reportState.COMPLETED:
                return <Check style={{ color: 'green' }} />;
            default:
                return <AlertCircle style={{ color: 'yellow' }} />;
        }
    };

    static getStateName = (state) => {
        switch (state) {
            case this.reportState.DISCARDED:
                return 'discarded';
            case this.reportState.PENDING:
                return 'pending';
            case this.reportState.SELECTED_FOR_PROCESSING:
                return 'selected_for_processing';
            case this.reportState.IN_PROGRESS:
                return 'in_progress';
            case this.reportState.FAILED:
                return 'failed';
            case this.reportState.EXCEEDED_RETRIES:
                return 'exceeded_retries';
            case this.reportState.COMPLETED:
                return 'completed';
            default:
                return 'unknown_type';
        }
    };

    static translateResellerId = (idToTranslate, translationsArray) => {
        const translations = [];

        console.log(idToTranslate, translationsArray)

        if(typeof idToTranslate === 'string' || idToTranslate instanceof String) {
            idToTranslate = idToTranslate.split(',');
        }

        console.log(idToTranslate, translationsArray)
        if(Array.isArray(idToTranslate)) {
            idToTranslate.map(toTranslateId => {
                translationsArray.map(translation => {
                    if(parseInt(toTranslateId) === translation.id) {
                        translations.push(translation.mainname);
                    }
                })
            })
        }


        return translations.join(',');
    }
}
